const phoneRegex = /^(?:\+?1)?(\d{3})(\d{3})(\d{4})$/

export const phone = num => (num ? num.replace(phoneRegex, '$1-$2-$3') : undefined)
